// extracted by mini-css-extract-plugin
export var box = "_3y-1";
export var checkboxRow = "_3y-8";
export var checked = "_3y-2";
export var descriptionSpacer = "_3y-a";
export var disabled = "_3y-3";
export var icon = "_3y-6";
export var input = "_3y-0";
export var labelSpacer = "_3y-9";
export var medium = "_3y-5";
export var small = "_3y-4";
export var text = "_3y-7";